import React, { useEffect, useState } from 'react';
import { Stack, Typography } from '@mui/material';
import { AuditLogEventName } from 'pages/AuditLogPage/AuditLogViewPage/styles';
import { IAuditLogItemResponse } from 'models/auditLog';
import { DetailsTemplate, EDetailsPageTypes } from 'components/templates/DetailsTemplate';
import { useTranslations } from 'hooks/useTranslations';
import { Grid } from '@mui/system';

interface IAdministrationLoginLogosEventDetails {
  auditLog: IAuditLogItemResponse;
}

const AdministrationLoginLogosEventDetails = ({
  auditLog,
}: IAdministrationLoginLogosEventDetails) => {
  const [details, setDetails] = useState<any | null>();
  const [previousDetails, setPreviousDetails] = useState<any | null>();
  const { t } = useTranslations();

  useEffect(() => {
    if (auditLog?.previousObjectValue) {
      (async () => {
        const previousObjectValue = auditLog?.previousObjectValue as any;
        const previousData = {
          text: previousObjectValue.text || previousObjectValue.fileName || '',
          eventName: auditLog.eventName || '',
          type:
            previousObjectValue.type.charAt(0).toUpperCase() +
            previousObjectValue.type.slice(1).toLowerCase() || '',
        };
        setPreviousDetails(previousData);
      })();
    }

    if (auditLog?.postObjectValue) {
      (async () => {
        const postObjectValue = auditLog?.postObjectValue as any;
        const postData = {
          text: postObjectValue.text || postObjectValue.fileName || '',
          eventName: auditLog.eventName || '',
          type:
            postObjectValue.type.charAt(0).toUpperCase() +
            postObjectValue.type.slice(1).toLowerCase() || '',
        };
        setDetails(postData);
      })();
    }
  }, [auditLog]);

  return (
    <>
      {previousDetails && (
        <>
          <AuditLogEventName>
            <Typography variant="h5">
              {`${t('logosSetup.header')} ${t('auditLogDetails.before.event.title')}`}
            </Typography>
          </AuditLogEventName>
          <DetailsTemplate
            pageType={EDetailsPageTypes.auditLogView}
            title={previousDetails.eventName}
            disableActions={true}
          >

            <Grid size={{ xs: 12 }}>
              <Grid size={{ xs: 12 }}>
                <Stack>
                  <Typography variant="subtitle2" sx={{ marginBottom: '4px' }}>
                    {previousDetails.type}
                  </Typography>
                  <Typography variant="body2">{previousDetails.text}</Typography>
                </Stack>
              </Grid>
            </Grid>
          </DetailsTemplate>
        </>
      )}

      {details && (
        <>
          <AuditLogEventName sx={{ marginTop: '20px' }}>
            <Typography variant="h5">
              {`${t('logosSetup.header')} ${t('auditLogDetails.post.event.title')}`}
            </Typography>
          </AuditLogEventName>
          <DetailsTemplate
            pageType={EDetailsPageTypes.auditLogView}
            title={details.eventName}
            disableActions={true}
          >
            <Grid size={{ xs: 12 }}>
              <Grid size={{ xs: 12 }}>
                <Stack>
                  <Typography variant="subtitle2" sx={{ marginBottom: '4px' }}>
                    {details.type}
                  </Typography>
                  <Typography variant="body2">{details.text}</Typography>
                </Stack>
              </Grid>
            </Grid>
          </DetailsTemplate>
        </>
      )
      }
    </>
  );
};

export default AdministrationLoginLogosEventDetails;
